<template>
  <div :class="$attrs.class">
    <label
      v-if="label"
      class="form-label"
      :for="id">{{ label }}:</label>
    <input
      :id="id"
      :autocomplete="autocomplete"
      ref="input"
      v-bind="{ ...$attrs, class: null }"
      class="form-input"
      :class="[{ error: error }, inputClass]"
      :type="type"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)">
    <div v-if="error" class="form-error">
      {{ error }}
    </div>
  </div>
</template>

<script lang="js">
export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default () {
                return `text-input-${self.crypto.randomUUID()}`
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        error: String,
        autocomplete: String,
        label: String,
        modelValue: {
            type: [String, Number],
        },
        inputClass: String,
    },
    emits: ['update:modelValue'],
    methods: {
        focus () {
            this.$refs.input.focus()
        },
        select () {
            this.$refs.input.select()
        },
        setSelectionRange (start, end) {
            this.$refs.input.setSelectionRange(start, end)
        },
    },
}
</script>

<style scoped>
input:disabled {
  background-color: rgb(233, 236, 239);
}
</style>
